import { CYCLE_ENDS } from '../constants';
import type { ICycle } from '../types';

const cycleEnds = CYCLE_ENDS.map((end) => new Date(end));

/**
 * The week `now` falls into. Before the promo it is the first one, after the
 * last reward it stays the last one, so the page always has a week to show.
 */
export const getCurrentCycle = (
  promoStart: string,
  now = new Date()
): ICycle => {
  const found = cycleEnds.findIndex((end) => now < end);
  const index = found === -1 ? cycleEnds.length - 1 : found;

  return {
    index,
    start: index === 0 ? new Date(promoStart) : cycleEnds[index - 1],
    end: cycleEnds[index],
    isLast: index === cycleEnds.length - 1,
  };
};

export const CYCLES_COUNT = cycleEnds.length;
